import axios from 'axios'
import qs from 'qs'
import app from '../src/main'

let loginFailFlag = false
const config = process.env.NODE_ENV === 'development' ? {
  // baseUrl: 'http://192.168.1.38:8199',
  // baseUrl: 'http://47.114.110.8:8199',
  baseUrl: 'https://api.qsyhbgj.com',
  uploadUrl: 'http://qn.ep-home.com/'
} : {
  // baseUrl: 'http://192.168.0.116:8199',
  // baseUrl: 'http://47.114.110.8:8199',
  baseUrl: 'https://api.qsyhbgj.com',
  uploadUrl: 'http://qn.ep-home.com/'
}
function epApiPost (path, params = {}) {
  var phone = sessionStorage.getItem('qs_phone') || ''
  return axios({
    method: 'post',
    // timeout: 50000000,
    url: path.includes('://') ? path : config.baseUrl + path,
    data: qs.stringify(Object.assign({}, params)),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer ' + (qs.parse(location.search.split('?')[1]).token || sessionStorage.getItem('qs_token') || ''),
      phone: phone,
      appId: 'p_web'
    }
  }).then(response => {
    return loginHandle(response)
  }).catch((e) => {
    return { data: {} }
  })
}
function epApiGet (path, params = {}) {
  var phone = sessionStorage.getItem('qs_phone') || ''
  return axios({
    method: 'get',
    // timeout: 50000000,
    url: path.includes('://') ? path : config.baseUrl + path,
    params: Object.assign({}, params),
    headers: {
      Authorization: 'Bearer ' + (qs.parse(location.search.split('?')[1]).token || sessionStorage.getItem('qs_token') || ''),
      phone: phone,
      appId: 'p_web'
    }
  }).then(response => {
    return loginHandle(response)
  }).catch((e) => {
    return {}
  })
}
function epApiFormPost (path, params = {}) {
  var phone = sessionStorage.getItem('qs_phone') || ''
  const formParam = new FormData()
  Object.keys(params).forEach(item => {
    formParam.append(item, params[item])
  })
  return axios.post(config.baseUrl + path, formParam, {
    // timeout: 50000000,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + (qs.parse(location.search.split('?')[1]).token || sessionStorage.getItem('qs_token') || ''),
      phone: phone,
      appId: 'p_web'
    }
  }).then(response => {
    return loginHandle(response)
  }).catch((e) => {
    return { data: {} }
  })
}

function loginHandle (response) {
  if (response.data && response.data.code && response.data.code === 2001 && !loginFailFlag) {
    loginFailFlag = true
    app.$toast.text(response.data.message || '登陆失效，请重新登陆', {
      duration: 1800
    })
    return {}
  } else if (response.data && response.data.code && response.data.code !== 200 && response.data.code !== 2006 && response.data.code !== 888 && response.data.code !== 520 && response.data.code !== 500) {
    app.$toast.text(response.data.message, {
      duration: 1800
    })
    return response.data
  } else {
    return response.data
  }
}

export default {
  /* 登录注册 */
  login (params) {
    return epApiPost('/appUser/login', params)
  },
  /* 微信相关 */
  getWeixinConfig () {
    return epApiGet('http://192.168.0.103:8081/getWeixinConfig')
  },
  /* 通用 */
  getHotList (params) {
    return epApiGet('/notice/hotList', params)
  },
  /* 备注 */
  remarks (params) {
    return epApiGet('/personal/remarks', params)
  },
  /* 手册模块 */
  getFileRank (params) {
    return epApiGet('/rank/rankingList', params)
  },
  getRecommendList (params) {
    return epApiGet('/notice/commonData', params)
  },
  /* 投票 */
  getVoteMenus (params) {
    return epApiGet('/corporate/corporateCatalogs', params)
  },
  getVoteList (params) {
    return epApiGet('/corporate/corporateList', params)
  },
  getVoteDetail (params) {
    return epApiGet('/corporate/corporate', params)
  },
  getVoteSearch (params) {
    return epApiGet('/corporate/corporateSearch', params)
  },
  doVote (params) {
    return epApiGet('/corporate/vote', params)
  },
  applyVote (params) {
    return epApiFormPost('/corporate/signUp', params)
  },
  getVoteComments (params) {
    return epApiGet('/corporate/commentDisplay', params)
  },
  voteComment (params) {
    return epApiGet('/corporate/comment', params)
  },
  deleteVoteComment (params) {
    return epApiGet('/corporate/commentDelete', params)
  },
  getCreditDetailById (params) {
    return epApiGet('/creditPlatform/numbersCode', params)
  },
  getFileDetail (params) {
    return epApiGet('/file/fileId', params)
  },
  countDownload (params) {
    return epApiGet('/appUser/fileNumbers', params)
  },
  subscription (params) {
    return epApiFormPost('/appUser/subscription', params)
  },
  /* 报告表模块 */
  uploadFileReport (params, progressCb, cancelToken) {
    return epApiFormPost('/pFileUpload/pUpload', params, progressCb, cancelToken)
  },
  getSuggestReport (params) {
    return epApiGet('/pCatalogs/pSs', params)
  },
  getMenusReport (params) {
    return epApiGet('/pCatalogs/pCatalogsPC', params)
  },
  getMenusDetailReport (params) {
    return epApiGet('/pCatalogs/pCatalogEnd', params)
  },
  getFavoriteListReport (params) {
    return epApiGet('/pCollection/pCollectionList', params)
  },
  getFavoriteListFolderReport (params) {
    return epApiGet('/pCollection/pFolderList', params)
  },
  reNameFolderReport (params) {
    return epApiGet('/pCollection/rName', params)
  },
  addFavoriteReport (params) {
    return epApiGet('/pCollection/pCollection', params)
  },
  deleteFavoriteReport (params) {
    return epApiGet('/pCollection/pCancelCollection', params)
  },
  addFavFolderReport (params) {
    return epApiGet('/pCollection/pAddFolder', params)
  },
  deleteFavFolderReport (params) {
    return epApiGet('/pCollection/pDeleteFolder', params)
  },
  transfFavPositionReport (params) {
    return epApiGet('/pCollection/pMove', params)
  },
  isShowUploadReport () {
    return epApiGet('/change/isUploadExcel')
  },
  getUploadListReport (params) {
    return epApiGet('/personal/presentationList', params)
  },
  /* 其它模块 */
  uploadFileOther (params, progressCb, cancelToken) {
    return epApiFormPost('/sFileUpload/sUpload', params, progressCb, cancelToken)
  },
  getSuggestOther (params) {
    return epApiGet('/sCatalogs/sSs', params)
  },
  getMenusOther (params) {
    return epApiGet('/sCatalogs/sCatalogsPC', params)
  },
  getMenusDetailOther (params) {
    return epApiGet('/sCatalogs/sCatalogEnd', params)
  },
  getFavoriteListOther (params) {
    return epApiGet('/sCollection/sCollectionList', params)
  },
  getFavoriteListFolderOther (params) {
    return epApiGet('/sCollection/sFolderList', params)
  },
  reNameFolderOther (params) {
    return epApiGet('/sCollection/sRName', params)
  },
  addFavoriteOther (params) {
    return epApiGet('/sCollection/sCollection', params)
  },
  deleteFavoriteOther (params) {
    return epApiGet('/sCollection/sCancelCollection', params)
  },
  addFavFolderOther (params) {
    return epApiGet('/sCollection/sAddFolder', params)
  },
  deleteFavFolderOther (params) {
    return epApiGet('/sCollection/sDeleteFolder', params)
  },
  transfFavPositionOther (params) {
    return epApiGet('/sCollection/sMove', params)
  },
  getUploadListOther (params) {
    return epApiGet('/personal/shareList', params)
  },
  /* 手册模块 */
  uploadFile (params, progressCb, cancelToken) {
    return epApiFormPost('/fileUpload/upload', params, progressCb, cancelToken)
  },
  getSuggest (params) {
    return epApiGet('/catalogs/ss', params)
  },
  getMenus (params) {
    return epApiGet('/catalogs/catalogsPC', params)
  },
  getMenusDetail (params) {
    return epApiGet('/catalogs/catalogEnd', params)
  },
  /* 问答模块 */
  getSuggestAsk (params) {
    return epApiGet('/tCatalogs/tSs', params)
  },
  getMenusAsk (params) {
    return epApiGet('/tCatalogs/tCatalogsPC', params)
  },
  getMenusDetailAsk (params) {
    return epApiGet('/tCatalogs/tCatalogEnd', params)
  },
  getFavoriteListAsk (params) {
    return epApiGet('/tCollection/tCollectionList', params)
  },
  getFavoriteListFolderAsk (params) {
    return epApiGet('/tCollection/tFolderList', params)
  },
  reNameFolderAsk (params) {
    return epApiGet('/tCollection/tName', params)
  },
  addFavoriteAsk (params) {
    return epApiGet('/tCollection/tCollection', params)
  },
  deleteFavoriteAsk (params) {
    return epApiGet('/tCollection/tCancelCollection', params)
  },
  addFavFolderAsk (params) {
    return epApiGet('/tCollection/tAddFolder', params)
  },
  deleteFavFolderAsk (params) {
    return epApiGet('/tCollection/tDeleteFolder', params)
  },
  transfFavPositionAsk (params) {
    return epApiGet('/tCollection/tMove', params)
  },
  /* 查看文件次数限制 */
  openFileLimitCheck (params) {
    return epApiGet('/appUser/file', params)
  },
  /* 电脑端版本 */
  getVersionWin () {
    return epApiGet('https://image.qsyhbgj.com/latest.yml')
  },
  getVersionMac () {
    return epApiGet('https://image.qsyhbgj.com/latest-mac.yml')
  },
  /* 信用平台 */
  getCreditCoList (params) {
    return epApiGet('/creditPlatform/creditUnit', params)
  },
  searchCredit (params) {
    return epApiGet('/creditPlatform/ss', params)
  },
  /* 公示 */
  publicSearch (params) {
    return epApiGet('/publicity/PublicitySearch', params)
  },
  getPublicClassList (params) {
    return epApiGet('/publicity/publicityCatalogs', params)
  },
  getPublicAreaList (params) {
    return epApiGet('/publicity/region', params)
  },
  getPublicList (params) {
    return epApiGet('/publicity/publicityList', params)
  },
  getPublicDetail (params) {
    return epApiGet('/publicity/publicity', params)
  },
  getPublicComments (params) {
    return epApiGet('/publicity/commentDisplay', params)
  },
  deletePublicComment (params) {
    return epApiGet('/publicity/commentDelete', params)
  },
  publicComment (params) {
    return epApiGet('/publicity/comment', params)
  },
  publicityListOne (params) {
    return epApiFormPost('/publicity/publicityListOne', params)
  },
  publicityOne (params) {
    return epApiFormPost('/publicity/publicityOne', params)
  },
  // 公示附件
  enclosure (params) {
    return epApiGet('/publicity/enclosure', params)
  },
  enclosureNumber (params) {
    return epApiGet('/publicity/enclosureNumber', params)
  },
  publicityAnnex (params) {
    return epApiGet('/publicity/publicityAnnex', params)
  },
  publicityDownloadOne (params) {
    return epApiGet('/publicity/publicityDownloadOne', params)
  },
  // 环保管家信息公示
  hbEssentialInformationEnquiry (params) {
    return epApiGet('/hbEssentialInformation/hbEssentialInformationEnquiry', params)
  },
  hbCompanyDisclosureEnquiry (params) {
    return epApiGet('/hbCompanyDisclosure/hbCompanyDisclosureEnquiry', params)
  },
  hbCompanyEnclosureEnquiry (params) {
    return epApiGet('/hbCompanyDisclosure/hbCompanyEnclosureEnquiry', params)
  },
  hbAnnouncementSearch (params) {
    return epApiFormPost('/hbAnnouncement/hbAnnouncementSearch', params)
  },
  // 排污许可 信息公开表公示信息新1
  hbDisclosureOneEnquiry (params) {
    return epApiGet('/hbDisclosureOne/hbDisclosureOneEnquiry', params)
  },
  // 排污许可 信息公开表公示信息新2
  hbDisclosureTwoEnquiry (params) {
    return epApiGet('/hbDisclosureTwo/hbDisclosureTwoEnquiry', params)
  },
  // 排污许可 信息公开表公示信息新3
  hbDisclosureThreeEnquiry (params) {
    return epApiGet('/hbDisclosureThree/hbDisclosureThreeEnquiry', params)
  },
  hbDisclosureOneByEnquiry (params) {
    return epApiGet('/hbDisclosureOne/hbDisclosureOneByEnquiry', params)
  },
  /* 直播 */
  spLiveEnquiry (params) {
    return epApiGet('/appUser/broadcastEnquiry', params)
  },
  spLiveUpdate (params) {
    return epApiGet('/appUser/broadcastUpdate', params)
  },
  spLiveDmAdd (params) {
    return epApiGet('/cdLiveBarrage/cdLiveBarrageAdd', params)
  },
  spLiveDmEnquiry (params) {
    return epApiGet('/cdLiveBarrage/cdLiveBarrageEnquiry', params)
  },
  spLiveByEnquiry (params) {
    return epApiGet('/appUser/broadcastByEnquiry', params)
  },
  spLiveByUpdate (params) {
    return epApiFormPost('/appUser/broadcastByUpdate', params)
  },
  spLiveReservationEnquiry (params) {
    return epApiGet('/cdLiveBarrage/cdReservationEnquiry', params)
  },
  spLiveReservationUpdate (params) {
    return epApiFormPost('/cdLiveBarrage/cdReservationUpdate', params)
  },
  // 互助交流
  jcDetectionProblemSearch (params) {
    return epApiGet('/jcDetectionProblem/jcDetectionProblemSearch', params)
  },
  jcDetectionEnclosureEnquiry (params) {
    return epApiFormPost('/jcDetectionProblem/jcDetectionEnclosureEnquiry', params)
  },
  jcDetectionCommentsEnquiry (params) {
    return epApiGet('/jcDetectionComments/jcDetectionCommentsEnquiry', params)
  },
  /* 获取基本信息 */
  getUserInfo (params) {
    return epApiGet('/personal/userInfo', params)
  },
  getPhoneCode (params) {
    return epApiGet('/appUser/getcode', params)
  },
  register (params) {
    return epApiPost('/appUser/register', params)
  },
  resetPassword (params) {
    return epApiPost('/appUser/getPassWord', params)
  },
  // 支付宝支付
  payTest (params) {
    return epApiPost('/pay/pay', params)
  },
  // 环保管家 在线监测
  hbOnlineHome (params) {
    return epApiGet('/hbOnlineMonitoring/HbOnlineHome', params)
  },
  hbOnlineMonitoringAdd (params) {
    return epApiFormPost('/hbOnlineMonitoring/hbOnlineMonitoringAdd', params)
  },
  hbOnlineMonitoringDelete (params) {
    return epApiGet('/hbOnlineMonitoring/hbOnlineMonitoringDelete', params)
  },
  hbOnlineMonitoringUpdate (params) {
    return epApiFormPost('/hbOnlineMonitoring/hbOnlineMonitoringUpdate', params)
  },
  hbOnlineMonitoringEnquiry (params) {
    return epApiGet('/hbOnlineMonitoring/hbOnlineMonitoringEnquiry', params)
  },
  hbOnlineMonitoringSearch (params) {
    return epApiGet('/hbOnlineMonitoring/hbOnlineMonitoringSearch', params)
  },
  hbCoverInterfaceAdd (params) {
    return epApiFormPost('/hbCoverInterface/hbCoverInterfaceAdd', params)
  },
  hbCoverInterfaceDelete (params) {
    return epApiGet('/hbCoverInterface/hbCoverInterfaceDelete', params)
  },
  hbCoverInterfaceEnquiry (params) {
    return epApiGet('/hbCoverInterface/hbCoverInterfaceEnquiry', params)
  },
  hbManagementInformationEnquiry (params) {
    return epApiGet('/hbManagementInformation/hbManagementInformationEnquiry', params)
  },
  hbManagementInformationUpdate (params) {
    return epApiFormPost('/hbManagementInformation/hbManagementInformationUpdate', params)
  },
  hbManagementInformationDelete (params) {
    return epApiGet('/hbManagementInformation/hbManagementInformationDelete', params)
  },
  hbManagementInformationUpload (params) {
    return epApiFormPost('/hbManagementInformation/hbManagementInformationUpload', params)
  },
  hbManagementInformationDownload (params) {
    return epApiGet('/hbManagementInformation/hbManagementInformationDownload', params)
  },
  hbManagementInformationImport (params) {
    return epApiFormPost('/hbManagementInformation/hbManagementInformationImport', params)
  },
  hbOnlineAdd (params) {
    return epApiFormPost('/hbOnline/hbOnlineAdd', params)
  },
  hbOnlineDelete (params) {
    return epApiFormPost('/hbOnline/hbOnlineDelete', params)
  },
  hbOnlineUpdate (params) {
    return epApiFormPost('/hbOnline/hbOnlineUpdate', params)
  },
  hbOnlineEnquiry (params) {
    return epApiGet('/hbOnline/hbOnlineEnquiry', params)
  },
  hbMapViewEnquiry (params) {
    return epApiGet('/hbMapView/hbMapViewEnquiry', params)
  },
  hbMapViewAdd (params) {
    return epApiFormPost('/hbMapView/hbMapViewAdd', params)
  },
  appUserCompany (params) {
    return epApiGet('/appUser/appUserCompany', params)
  },
  appUserMapProvinceEnquiry (params) {
    return epApiGet('/appUser/appUserMapProvinceEnquiry', params)
  },
  appUserMapProvinceUpdate (params) {
    return epApiGet('/appUser/appUserMapProvinceUpdate', params)
  },
  appUserUpdate (params) {
    return epApiFormPost('/appUser/appUserUpdate', params)
  },
  // 环保管家
  /* 人事中心接口 */
  appUserAdd (params) {
    return epApiFormPost('/appUser/appUserAdd', params)
  },
  appUserDelete (params) {
    return epApiFormPost('/appUser/appUserDelete', params)
  },
  appUserEnquiry (params) {
    return epApiFormPost('/appUser/appUserEnquiry', params)
  },
  appUserSearch (params) {
    return epApiFormPost('/appUser/appUserSearch', params)
  },
  // 环保管家表格模块
  // 环保管家 管理制度表 岗位职责
  hbManageScheduleAdd (params) {
    return epApiFormPost('/hbManageSchedule/hbManageScheduleAdd', params)
  },
  hbManageScheduleEnquiry (params) {
    return epApiGet('/hbManageSchedule/hbManageScheduleEnquiry', params)
  },
  hbManageScheduleUpdate (params) {
    return epApiFormPost('/hbManageSchedule/hbManageScheduleUpdate', params)
  },
  hbManageScheduleDelete (params) {
    return epApiFormPost('/hbManageSchedule/hbManageScheduleDelete', params)
  },
  hbManageScheduleImport (params) {
    return epApiFormPost('/hbManageSchedule/hbManageScheduleImport', params)
  },
  hbManageScheduleDownload (params) {
    return epApiGet('/hbManageSchedule/hbManageScheduleDownload', params)
  },
  // 环保管家 管理组织机构
  hbManageOrganizationAdd (params) {
    return epApiFormPost('/hbManageOrganization/hbManageOrganizationAdd', params)
  },
  hbManageOrganizationEnquiry (params) {
    return epApiGet('/hbManageOrganization/hbManageOrganizationEnquiry', params)
  },
  hbManageOrganizationPicture (params) {
    return epApiFormPost('/hbManageOrganization/hbManageOrganizationPicture', params)
  },
  // 环保管家 工作年度计划
  hbWorkPlanAdd (params) {
    return epApiFormPost('/hbWorkPlan/hbWorkPlanAdd', params)
  },
  hbWorkPlanEnquiry (params) {
    return epApiGet('/hbWorkPlan/hbWorkPlanEnquiry', params)
  },
  hbWorkPlanUpdate (params) {
    return epApiFormPost('/hbWorkPlan/hbWorkPlanUpdate', params)
  },
  hbWorkPlanDelete (params) {
    return epApiFormPost('/hbWorkPlan/hbWorkPlanDelete', params)
  },
  hbWorkPlanImport (params) {
    return epApiFormPost('/hbWorkPlan/hbWorkPlanImport', params)
  },
  hbWorkPlanDownload (params) {
    return epApiGet('/hbWorkPlan/hbWorkPlanDownload', params)
  },
  // 环保管家 土地污染隐患排查
  hbEffectSurveyAdd (params) {
    return epApiFormPost('/hbEffectSurvey/hbEffectSurveyAdd', params)
  },
  hbEffectSurveyEnquiry (params) {
    return epApiGet('/hbEffectSurvey/hbEffectSurveyEnquiry', params)
  },
  hbEffectSurveyUpdate (params) {
    return epApiFormPost('/hbEffectSurvey/hbEffectSurveyUpdate', params)
  },
  hbEffectSurveyDelete (params) {
    return epApiFormPost('/hbEffectSurvey/hbEffectSurveyDelete', params)
  },
  // 环保管家 土地污染隐患排查 附件
  hbEffectEnclosureEnquiry (params) {
    return epApiGet('/hbEffectSurvey/hbEffectEnclosureEnquiry', params)
  },
  hbEffectEnclosureUpload (params) {
    return epApiFormPost('/hbEffectSurvey/hbEffectEnclosureUpload', params)
  },
  hbEffectEnclosureDelete (params) {
    return epApiFormPost('/hbEffectSurvey/hbEffectEnclosureDelete', params)
  },
  // 环保管家 区块水土保持方案
  hbKeepProgramAdd (params) {
    return epApiFormPost('/hbKeepProgram/hbKeepProgramAdd', params)
  },
  hbKeepProgramEnquiry (params) {
    return epApiGet('/hbKeepProgram/hbKeepProgramEnquiry', params)
  },
  hbKeepProgramUpdate (params) {
    return epApiFormPost('/hbKeepProgram/hbKeepProgramUpdate', params)
  },
  hbKeepProgramDelete (params) {
    return epApiFormPost('/hbKeepProgram/hbKeepProgramDelete', params)
  },
  // 企业概况 基本情况
  hbEssentialInformationAdd (params) {
    return epApiFormPost('/hbEssentialInformation/hbEssentialInformationAdd', params)
  },
  hbEssentialInformationDelete (params) {
    return epApiFormPost('/hbEssentialInformation/hbEssentialInformationDelete', params)
  },
  // 导入排污许可证
  hbImplementReportMo (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportMo', params)
  },
  // 企业概况 环保工程
  hbEngineeringAdd (params) {
    return epApiFormPost('/hbEngineering/hbEngineeringAdd', params)
  },
  hbEngineeringEnquiry (params) {
    return epApiGet('/hbEngineering/hbEngineeringEnquiry', params)
  },
  hbEngineeringUpdate (params) {
    return epApiFormPost('/hbEngineering/hbEngineeringUpdate', params)
  },
  hbEngineeringDelete (params) {
    return epApiFormPost('/hbEngineering/hbEngineeringDelete', params)
  },
  // 企业概况 管理体系
  hbPollutantCertificatesAdd (params) {
    return epApiFormPost('/hbPollutantCertificates/hbPollutantCertificatesAdd', params)
  },
  hbPollutantCertificatesEnquiry (params) {
    return epApiGet('/hbPollutantCertificates/hbPollutantCertificatesEnquiry', params)
  },
  hbPollutantCertificatesUpdate (params) {
    return epApiFormPost('/hbPollutantCertificates/hbPollutantCertificatesUpdate', params)
  },
  hbPollutantCertificatesDelete (params) {
    return epApiFormPost('/hbPollutantCertificates/hbPollutantCertificatesDelete', params)
  },
  // 企业概况 产品及产能
  hbProductAdd (params) {
    return epApiFormPost('/hbProduct/hbProductAdd', params)
  },
  hbProductEnquiry (params) {
    return epApiGet('/hbProduct/hbProductEnquiry', params)
  },
  hbProductUpdate (params) {
    return epApiFormPost('/hbProduct/hbProductUpdate', params)
  },
  hbProductDelete (params) {
    return epApiFormPost('/hbProduct/hbProductDelete', params)
  },
  // 企业概况 储罐
  hbStorageTankAdd (params) {
    return epApiFormPost('/hbStorageTank/hbStorageTankAdd', params)
  },
  hbStorageTankEnquiry (params) {
    return epApiGet('/hbStorageTank/hbStorageTankEnquiry', params)
  },
  hbStorageTankUpdate (params) {
    return epApiFormPost('/hbStorageTank/hbStorageTankUpdate', params)
  },
  hbStorageTankDelete (params) {
    return epApiFormPost('/hbStorageTank/hbStorageTankDelete', params)
  },
  // 企业概况 设备及管线密封点
  hbEquipmentAdd (params) {
    return epApiFormPost('/hbEquipment/hbEquipmentAdd', params)
  },
  hbEquipmentEnquiry (params) {
    return epApiGet('/hbEquipment/hbEquipmentEnquiry', params)
  },
  hbEquipmentUpdate (params) {
    return epApiFormPost('/hbEquipment/hbEquipmentUpdate', params)
  },
  hbEquipmentDelete (params) {
    return epApiFormPost('/hbEquipment/hbEquipmentDelete', params)
  },
  // 企业概况 原辅材料
  hbAccessoriesAdd (params) {
    return epApiFormPost('/hbAccessories/hbAccessoriesAdd', params)
  },
  hbAccessoriesEnquiry (params) {
    return epApiGet('/hbAccessories/hbAccessoriesEnquiry', params)
  },
  hbAccessoriesUpdate (params) {
    return epApiFormPost('/hbAccessories/hbAccessoriesUpdate', params)
  },
  hbAccessoriesDelete (params) {
    return epApiFormPost('/hbAccessories/hbAccessoriesDelete', params)
  },
  // 企业概况 燃料
  hbFuelAdd (params) {
    return epApiFormPost('/hbFuel/hbFuelAdd', params)
  },
  hbFuelEnquiry (params) {
    return epApiGet('/hbFuel/hbFuelEnquiry', params)
  },
  hbFuelUpdate (params) {
    return epApiFormPost('/hbFuel/hbFuelUpdate', params)
  },
  hbFuelDelete (params) {
    return epApiFormPost('/hbFuel/hbFuelDelete', params)
  },
  // 企业概况 上传图片
  hbPictureUpload (params) {
    return epApiFormPost('/hbPicture/hbPictureUpload', params)
  },
  hbPictureEnquiry (params) {
    return epApiGet('/hbPicture/hbPictureEnquiry', params)
  },
  hbPictureDelete (params) {
    return epApiFormPost('/hbPicture/hbPictureDelete', params)
  },
  // 环保管家 单井环评及验收
  hbSingleWellAdd (params) {
    return epApiFormPost('/hbSingleWell/hbSingleWellAdd', params)
  },
  hbSingleWellEnquiry (params) {
    return epApiGet('/hbSingleWell/hbSingleWellEnquiry', params)
  },
  hbSingleWellUpdate (params) {
    return epApiFormPost('/hbSingleWell/hbSingleWellUpdate', params)
  },
  hbSingleWellDelete (params) {
    return epApiFormPost('/hbSingleWell/hbSingleWellDelete', params)
  },
  hbSingleWellUpload (params) {
    return epApiFormPost('/hbSingleWell/hbSingleWellUpload', params)
  },
  // 委托启动 环评单位 拟选单位
  hbEiaUnitAdd (params) {
    return epApiFormPost('/hbEiaUnit/hbEiaUnitAdd', params)
  },
  hbEiaUnitEnquiry (params) {
    return epApiGet('/hbEiaUnit/hbEiaUnitEnquiry', params)
  },
  hbEiaUnitUpdate (params) {
    return epApiFormPost('/hbEiaUnit/hbEiaUnitUpdate', params)
  },
  hbEiaUnitDelete (params) {
    return epApiFormPost('/hbEiaUnit/hbEiaUnitDelete', params)
  },
  // 委托启动 环评合同
  hbEiaContractAdd (params) {
    return epApiFormPost('/hbEiaContract/hbEiaContractAdd', params)
  },
  hbEiaContractEnquiry (params) {
    return epApiGet('/hbEiaContract/hbEiaContractEnquiry', params)
  },
  hbEiaContractUpdate (params) {
    return epApiFormPost('/hbEiaContract/hbEiaContractUpdate', params)
  },
  hbEiaContractDelete (params) {
    return epApiFormPost('/hbEiaContract/hbEiaContractDelete', params)
  },
  // 环评管理 资料整理
  hbMaterialAdd (params) {
    return epApiFormPost('/hbMaterial/hbMaterialAdd', params)
  },
  hbMaterialEnquiry (params) {
    return epApiGet('/hbMaterial/hbMaterialEnquiry', params)
  },
  hbMaterialUpdate (params) {
    return epApiFormPost('/hbMaterial/hbMaterialUpdate', params)
  },
  hbMaterialDelete (params) {
    return epApiFormPost('/hbMaterial/hbMaterialDelete', params)
  },
  // 环评管理 环评公示
  hbEiaPublicityAdd (params) {
    return epApiFormPost('/hbEiaPublicity/hbEiaPublicityAdd', params)
  },
  hbEiaPublicityEnquiry (params) {
    return epApiGet('/hbEiaPublicity/hbEiaPublicityEnquiry', params)
  },
  hbEiaPublicityUpdate (params) {
    return epApiFormPost('/hbEiaPublicity/hbEiaPublicityUpdate', params)
  },
  hbEiaPublicityDelete (params) {
    return epApiFormPost('/hbEiaPublicity/hbEiaPublicityDelete', params)
  },
  hbEnclosureEnquiry (params) {
    return epApiGet('/hbEnclosure/hbEnclosureEnquiry', params)
  },
  hbEnclosureUpload (params) {
    return epApiFormPost('/hbEnclosure/hbEnclosureUpload', params)
  },
  hbEnclosureDelete (params) {
    return epApiFormPost('/hbEnclosure/hbEnclosureDelete', params)
  },
  // 环评管理 环评评审
  hbEiaReviewAdd (params) {
    return epApiFormPost('/hbEiaReview/hbEiaReviewAdd', params)
  },
  hbEiaReviewEnquiry (params) {
    return epApiGet('/hbEiaReview/hbEiaReviewEnquiry', params)
  },
  hbEiaReviewUpdate (params) {
    return epApiFormPost('/hbEiaReview/hbEiaReviewUpdate', params)
  },
  hbEiaReviewDelete (params) {
    return epApiFormPost('/hbEiaReview/hbEiaReviewDelete', params)
  },
  hbReviewAnnexEnquiry (params) {
    return epApiGet('/hbReviewAnnex/hbReviewAnnexEnquiry', params)
  },
  hbReviewAnnexUpload (params) {
    return epApiFormPost('/hbReviewAnnex/hbReviewAnnexUpload', params)
  },
  hbReviewAnnexDelete (params) {
    return epApiFormPost('/hbReviewAnnex/hbReviewAnnexDelete', params)
  },
  // 环评管理 环评报批
  hbEiaApprovalAdd (params) {
    return epApiFormPost('/hbEiaApproval/hbEiaApprovalAdd', params)
  },
  hbEiaApprovalEnquiry (params) {
    return epApiGet('/hbEiaApproval/hbEiaApprovalEnquiry', params)
  },
  hbEiaApprovalUpdate (params) {
    return epApiFormPost('/hbEiaApproval/hbEiaApprovalUpdate', params)
  },
  hbEiaApprovalDelete (params) {
    return epApiFormPost('/hbEiaApproval/hbEiaApprovalDelete', params)
  },
  hbApprovalMaterialsEnquiry (params) {
    return epApiGet('/hbApprovalMaterials/hbApprovalMaterialsEnquiry', params)
  },
  hbApprovalMaterialsUpload (params) {
    return epApiFormPost('/hbApprovalMaterials/hbApprovalMaterialsUpload', params)
  },
  hbApprovalMaterialsDelete (params) {
    return epApiFormPost('/hbApprovalMaterials/hbApprovalMaterialsDelete', params)
  },
  // 环评管理 环评存档
  hbEiaArchivingAdd (params) {
    return epApiFormPost('/hbEiaArchiving/hbEiaArchivingAdd', params)
  },
  hbEiaArchivingEnquiry (params) {
    return epApiGet('/hbEiaArchiving/hbEiaArchivingEnquiry', params)
  },
  hbEiaArchivingUpdate (params) {
    return epApiFormPost('/hbEiaArchiving/hbEiaArchivingUpdate', params)
  },
  hbEiaArchivingDelete (params) {
    return epApiFormPost('/hbEiaArchiving/hbEiaArchivingDelete', params)
  },
  hbArchiveAttachmentEnquiry (params) {
    return epApiGet('/hbArchiveAttachment/hbArchiveAttachmentEnquiry', params)
  },
  hbArchiveAttachmentUpload (params) {
    return epApiFormPost('/hbArchiveAttachment/hbArchiveAttachmentUpload', params)
  },
  hbArchiveAttachmentDelete (params) {
    return epApiFormPost('/hbArchiveAttachment/hbArchiveAttachmentDelete', params)
  },
  // 排污许可 工程建设
  hbEngineeringBuildAdd (params) {
    return epApiFormPost('/hbEngineeringBuild/hbEngineeringBuildAdd', params)
  },
  hbEngineeringBuildEnquiry (params) {
    return epApiGet('/hbEngineeringBuild/hbEngineeringBuildEnquiry', params)
  },
  hbEngineeringBuildUpdate (params) {
    return epApiFormPost('/hbEngineeringBuild/hbEngineeringBuildUpdate', params)
  },
  hbEngineeringBuildDelete (params) {
    return epApiFormPost('/hbEngineeringBuild/hbEngineeringBuildDelete', params)
  },
  // 排污许可 执行报告
  hbImplementReportAdd (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportAdd', params)
  },
  hbImplementReportEnquiry (params) {
    return epApiGet('/hbImplementReport/hbImplementReportEnquiry', params)
  },
  hbImplementReportUpdate (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportUpdate', params)
  },
  hbImplementReportDelete (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportDelete', params)
  },
  monthlyReport (params) {
    return epApiFormPost('/hbImplementReport/monthlyReport', params)
  },
  quarterlyReport (params) {
    return epApiFormPost('/hbImplementReport/quarterlyReport', params)
  },
  annualReport (params) {
    return epApiFormPost('/hbImplementReport/annualReport', params)
  },
  hbImplementReportAnnual (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportAnnual', params)
  },
  hbImplementReportAllDelete (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportAllDelete', params)
  },
  // 排污许可 执行报告 环境管理要求
  hbRequirementsAdd (params) {
    return epApiFormPost('/hbRequirements/hbRequirementsAdd', params)
  },
  hbRequirementsEnquiry (params) {
    return epApiGet('/hbRequirements/hbRequirementsEnquiry', params)
  },
  hbRequirementsDelete (params) {
    return epApiFormPost('/hbRequirements/hbRequirementsDelete', params)
  },
  hbRequirementsUpdate (params) {
    return epApiFormPost('/hbRequirements/hbRequirementsUpdate', params)
  },
  // 排污许可 排污单位基本信息(其他)
  hbReportContentAdd (params) {
    return epApiFormPost('/hbReportContent/hbReportContentAdd', params)
  },
  hbReportContentEnquiry (params) {
    return epApiGet('/hbReportContent/hbReportContentEnquiry', params)
  },
  hbReportContentDelete (params) {
    return epApiFormPost('/hbReportContent/hbReportContentDelete', params)
  },
  hbReportContentUpdate (params) {
    return epApiFormPost('/hbReportContent/hbReportContentUpdate', params)
  },
  // 排污许可 执行报告 正常运转
  hbNormalOperationAdd (params) {
    return epApiFormPost('/hbNormalOperation/hbNormalOperationAdd', params)
  },
  hbNormalOperationEnquiry (params) {
    return epApiGet('/hbNormalOperation/hbNormalOperationEnquiry', params)
  },
  hbNormalOperationDelete (params) {
    return epApiFormPost('/hbNormalOperation/hbNormalOperationDelete', params)
  },
  hbNormalOperationUpdate (params) {
    return epApiFormPost('/hbNormalOperation/hbNormalOperationUpdate', params)
  },
  // 排污许可 执行报告 正常时段
  hbNormalPeriodAdd (params) {
    return epApiFormPost('/hbNormalPeriod/hbNormalPeriodAdd', params)
  },
  hbNormalPeriodEnquiry (params) {
    return epApiGet('/hbNormalPeriod/hbNormalPeriodEnquiry', params)
  },
  hbNormalPeriodDelete (params) {
    return epApiFormPost('/hbNormalPeriod/hbNormalPeriodDelete', params)
  },
  hbNormalPeriodUpdate (params) {
    return epApiFormPost('/hbNormalPeriod/hbNormalPeriodUpdate', params)
  },
  // 排污许可 执行报告 台账
  hbAccountManagementAdd (params) {
    return epApiFormPost('/hbAccountManagement/hbAccountManagementAdd', params)
  },
  hbAccountManagementEnquiry (params) {
    return epApiGet('/hbAccountManagement/hbAccountManagementEnquiry', params)
  },
  hbAccountManagementDelete (params) {
    return epApiFormPost('/hbAccountManagement/hbAccountManagementDelete', params)
  },
  hbAccountManagementUpdate (params) {
    return epApiFormPost('/hbAccountManagement/hbAccountManagementUpdate', params)
  },
  // 排污许可 执行报告 特殊时期废气污染物实际排放量
  hbSpecialPeriodAdd (params) {
    return epApiFormPost('/hbSpecialPeriod/hbSpecialPeriodAdd', params)
  },
  hbSpecialPeriodEnquiry (params) {
    return epApiGet('/hbSpecialPeriod/hbSpecialPeriodEnquiry', params)
  },
  hbSpecialPeriodDelete (params) {
    return epApiFormPost('/hbSpecialPeriod/hbSpecialPeriodDelete', params)
  },
  hbSpecialPeriodUpdate (params) {
    return epApiFormPost('/hbSpecialPeriod/hbSpecialPeriodUpdate', params)
  },
  // 排污许可 执行报告 信息公开情况
  hbInformationDisclosureAdd (params) {
    return epApiFormPost('/hbInformationDisclosure/hbInformationDisclosureAdd', params)
  },
  hbInformationDisclosureEnquiry (params) {
    return epApiGet('/hbInformationDisclosure/hbInformationDisclosureEnquiry', params)
  },
  hbInformationDisclosureDelete (params) {
    return epApiFormPost('/hbInformationDisclosure/hbInformationDisclosureDelete', params)
  },
  hbInformationDisclosureUpdate (params) {
    return epApiFormPost('/hbInformationDisclosure/hbInformationDisclosureUpdate', params)
  },
  // 排污许可 执行报告 查看办理意见
  hbHandlingOpinionsAdd (params) {
    return epApiFormPost('/hbHandlingOpinions/hbHandlingOpinionsAdd', params)
  },
  hbHandlingOpinionsEnquiry (params) {
    return epApiGet('/hbHandlingOpinions/hbHandlingOpinionsEnquiry', params)
  },
  hbHandlingOpinionsUpdate (params) {
    return epApiFormPost('/hbHandlingOpinions/hbHandlingOpinionsUpdate', params)
  },
  // 排污许可 执行报告 排污单位(燃料)
  hbEnterpriseInformationAdd (params) {
    return epApiFormPost('/hbEnterpriseInformation/hbEnterpriseInformationAdd', params)
  },
  hbEnterpriseInformationEnquiry (params) {
    return epApiGet('/hbEnterpriseInformation/hbEnterpriseInformationEnquiry', params)
  },
  hbEnterpriseInformationDelete (params) {
    return epApiFormPost('/hbEnterpriseInformation/hbEnterpriseInformationDelete', params)
  },
  hbEnterpriseInformationUpdate (params) {
    return epApiFormPost('/hbEnterpriseInformation/hbEnterpriseInformationUpdate', params)
  },
  // 排污许可 污染治理设施异常运转信息
  hbPollutionAnomalyAdd (params) {
    return epApiFormPost('/hbPollutionAnomaly/hbPollutionAnomalyAdd', params)
  },
  hbPollutionAnomalyEnquiry (params) {
    return epApiGet('/hbPollutionAnomaly/hbPollutionAnomalyEnquiry', params)
  },
  hbPollutionAnomalyUpdate (params) {
    return epApiFormPost('/hbPollutionAnomaly/hbPollutionAnomalyUpdate', params)
  },
  hbPollutionAnomalyDelete (params) {
    return epApiFormPost('/hbPollutionAnomaly/hbPollutionAnomalyDelete', params)
  },
  // 排污许可 自行储存/利用/处置设施情况
  hbSelfStorageAdd (params) {
    return epApiFormPost('/hbSelfStorage/hbSelfStorageAdd', params)
  },
  hbSelfStorageDelete (params) {
    return epApiGet('/hbSelfStorage/hbSelfStorageDelete', params)
  },
  hbSelfStorageUpdate (params) {
    return epApiFormPost('/hbSelfStorage/hbSelfStorageUpdate', params)
  },
  hbSelfStorageEnquiry (params) {
    return epApiFormPost('/hbSelfStorage/hbSelfStorageEnquiry', params)
  },
  // 排污许可 自行储存/利用/处置设施合规情况说明表
  hbInformationSheetAdd (params) {
    return epApiFormPost('/hbInformationSheet/hbInformationSheetAdd', params)
  },
  hbInformationSheetEnquiry (params) {
    return epApiGet('/hbInformationSheet/hbInformationSheetEnquiry', params)
  },
  hbInformationSheetUpdate (params) {
    return epApiFormPost('/hbInformationSheet/hbInformationSheetUpdate', params)
  },
  hbInformationSheetDelete (params) {
    return epApiFormPost('/hbInformationSheet/hbInformationSheetDelete', params)
  },
  // 排污许可 执行报告 超标排放量信息表
  hbExcessiveEmissionAdd (params) {
    return epApiFormPost('/hbExcessiveEmission/hbExcessiveEmissionAdd', params)
  },
  hbExcessiveEmissionEnquiry (params) {
    return epApiGet('/hbExcessiveEmission/hbExcessiveEmissionEnquiry', params)
  },
  hbExcessiveEmissionUpdate (params) {
    return epApiFormPost('/hbExcessiveEmission/hbExcessiveEmissionUpdate', params)
  },
  hbExcessiveEmissionDelete (params) {
    return epApiFormPost('/hbExcessiveEmission/hbExcessiveEmissionDelete', params)
  },
  hbExcessiveEmissionDownload (params) {
    return epApiFormPost('/hbExcessiveEmission/hbExcessiveEmissionDownload', params)
  },
  hbExcessiveEmissionImport (params) {
    return epApiFormPost('/hbExcessiveEmission/hbExcessiveEmissionImport', params)
  },
  // 排污许可 执行报告 实际排放量信息表
  hbActualEmissionsAdd (params) {
    return epApiFormPost('/hbActualEmissions/hbActualEmissionsAdd', params)
  },
  hbActualEmissionsUpdate (params) {
    return epApiFormPost('/hbActualEmissions/hbActualEmissionsUpdate', params)
  },
  hbActualEmissionsDelete (params) {
    return epApiFormPost('/hbActualEmissions/hbActualEmissionsDelete', params)
  },
  hbActualEmissionsEnquiry (params) {
    return epApiGet('/hbActualEmissions/hbActualEmissionsEnquiry', params)
  },
  // 环保管家 信息披露 生成报告
  hbImplementReportExportOne (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportExportOne', params)
  },
  hbImplementReportExportTwo (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportExportTwo', params)
  },
  hbImplementReportExportThree (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportExportThree', params)
  },
  hbImplementReportExportFour (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportExportFour', params)
  },
  // 环保管家 信息披露 关键环境信息提要
  hbChangesAdd (params) {
    return epApiFormPost('/hbChanges/hbChangesAdd', params)
  },
  hbChangesEnquiry (params) {
    return epApiGet('/hbChanges/hbChangesEnquiry', params)
  },
  hbChangesUpdate (params) {
    return epApiFormPost('/hbChanges/hbChangesUpdate', params)
  },
  hbChangesDelete (params) {
    return epApiFormPost('/hbChanges/hbChangesDelete', params)
  },
  // 环保管家 信息披露 企业基本信息
  hbProductsServicesAdd (params) {
    return epApiFormPost('/hbProductsServices/hbProductsServicesAdd', params)
  },
  hbProductsServicesEnquiry (params) {
    return epApiGet('/hbProductsServices/hbProductsServicesEnquiry', params)
  },
  hbProductsServicesUpdate (params) {
    return epApiFormPost('/hbProductsServices/hbProductsServicesUpdate', params)
  },
  hbProductsServicesDelete (params) {
    return epApiFormPost('/hbProductsServices/hbProductsServicesDelete', params)
  },
  // 环保管家 信息披露 企业环境管理信息 生态环境行政许可信息
  hbLicensingAdd (params) {
    return epApiFormPost('/hbLicensing/hbLicensingAdd', params)
  },
  hbLicensingEnquiry (params) {
    return epApiGet('/hbLicensing/hbLicensingEnquiry', params)
  },
  hbLicensingUpdate (params) {
    return epApiFormPost('/hbLicensing/hbLicensingUpdate', params)
  },
  hbLicensingDelete (params) {
    return epApiFormPost('/hbLicensing/hbLicensingDelete', params)
  },
  // 环保管家 信息披露 企业环境管理信息 投保环境污染责任保险信息
  hbEvaluationAdd (params) {
    return epApiFormPost('/hbEvaluation/hbEvaluationAdd', params)
  },
  hbEvaluationEnquiry (params) {
    return epApiGet('/hbEvaluation/hbEvaluationEnquiry', params)
  },
  hbEvaluationUpdate (params) {
    return epApiFormPost('/hbEvaluation/hbEvaluationUpdate', params)
  },
  hbEvaluationDelete (params) {
    return epApiFormPost('/hbEvaluation/hbEvaluationDelete', params)
  },
  // 环保管家 信息披露 污染物产生、治理与排放信息 污染防治设施信息
  hbPreventionAdd (params) {
    return epApiFormPost('/hbPrevention/hbPreventionAdd', params)
  },
  hbPreventionEnquiry (params) {
    return epApiGet('/hbPrevention/hbPreventionEnquiry', params)
  },
  hbPreventionUpdate (params) {
    return epApiFormPost('/hbPrevention/hbPreventionUpdate', params)
  },
  hbPreventionDelete (params) {
    return epApiFormPost('/hbPrevention/hbPreventionDelete', params)
  },
  // 环保管家 信息披露 污染物产生、治理与排放信息 主要水污染物、大气污染物排放相关信息
  hbPollutantEmissionAdd (params) {
    return epApiFormPost('/hbPollutantEmission/hbPollutantEmissionAdd', params)
  },
  hbPollutantEmissionEnquiry (params) {
    return epApiGet('/hbPollutantEmission/hbPollutantEmissionEnquiry', params)
  },
  hbPollutantEmissionUpdate (params) {
    return epApiFormPost('/hbPollutantEmission/hbPollutantEmissionUpdate', params)
  },
  hbPollutantEmissionDelete (params) {
    return epApiFormPost('/hbPollutantEmission/hbPollutantEmissionDelete', params)
  },
  // 环保管家 信息披露 污染物产生、治理与排放信息 自行监测相关信息表
  hbRelevantAdd (params) {
    return epApiFormPost('/hbRelevant/hbRelevantAdd', params)
  },
  hbRelevantEnquiry (params) {
    return epApiGet('/hbRelevant/hbRelevantEnquiry', params)
  },
  hbRelevantUpdate (params) {
    return epApiFormPost('/hbRelevant/hbRelevantUpdate', params)
  },
  hbRelevantDelete (params) {
    return epApiFormPost('/hbRelevant/hbRelevantDelete', params)
  },
  // 环保管家 信息披露 污染物产生、治理与排放信息 一般工业固体废物贮存或自行利用处置信息表
  hbWasteStorageAdd (params) {
    return epApiFormPost('/hbWasteStorage/hbWasteStorageAdd', params)
  },
  hbWasteStorageEnquiry (params) {
    return epApiGet('/hbWasteStorage/hbWasteStorageEnquiry', params)
  },
  hbWasteStorageUpdate (params) {
    return epApiFormPost('/hbWasteStorage/hbWasteStorageUpdate', params)
  },
  hbWasteStorageDelete (params) {
    return epApiFormPost('/hbWasteStorage/hbWasteStorageDelete', params)
  },
  // 环保管家 信息披露 污染物产生、治理与排放信息 噪声排放信息表
  hbInformationAdd (params) {
    return epApiFormPost('/hbInformation/hbInformationAdd', params)
  },
  hbInformationEnquiry (params) {
    return epApiGet('/hbInformation/hbInformationEnquiry', params)
  },
  hbInformationUpdate (params) {
    return epApiFormPost('/hbInformation/hbInformationUpdate', params)
  },
  hbInformationDelete (params) {
    return epApiFormPost('/hbInformation/hbInformationDelete', params)
  },
  // 环保管家 信息披露 污染物产生、治理与排放信息 危险废物信息表
  hbHazardousAdd (params) {
    return epApiFormPost('/hbHazardous/hbHazardousAdd', params)
  },
  hbHazardousEnquiry (params) {
    return epApiGet('/hbHazardous/hbHazardousEnquiry', params)
  },
  hbHazardousUpdate (params) {
    return epApiFormPost('/hbHazardous/hbHazardousUpdate', params)
  },
  hbHazardousDelete (params) {
    return epApiFormPost('/hbHazardous/hbHazardousDelete', params)
  },
  // 环保管家 信息披露 污染物产生、治理与排放信息 小结
  hbSummaryAdd (params) {
    return epApiFormPost('/hbSummary/hbSummaryAdd', params)
  },
  hbSummaryEnquiry (params) {
    return epApiGet('/hbSummary/hbSummaryEnquiry', params)
  },
  hbSummaryUpdate (params) {
    return epApiFormPost('/hbSummary/hbSummaryUpdate', params)
  },
  hbSummaryDelete (params) {
    return epApiFormPost('/hbSummary/hbSummaryDelete', params)
  },
  // 环保管家 信息披露 企业环境管理信息 碳排放信息 强制性清洁生产审核信息
  hbDisclosureAdd (params) {
    return epApiFormPost('/hbDisclosure/hbDisclosureAdd', params)
  },
  hbDisclosureEnquiry (params) {
    return epApiGet('/hbDisclosure/hbDisclosureEnquiry', params)
  },
  hbDisclosureUpdate (params) {
    return epApiFormPost('/hbDisclosure/hbDisclosureUpdate', params)
  },
  hbDisclosureDelete (params) {
    return epApiFormPost('/hbDisclosure/hbDisclosureDelete', params)
  },
  // 环保管家 信息披露 企业环境管理信息 生态环境应急信息
  hbEmergencyAdd (params) {
    return epApiFormPost('/hbEmergency/hbEmergencyAdd', params)
  },
  hbEmergencyEnquiry (params) {
    return epApiGet('/hbEmergency/hbEmergencyEnquiry', params)
  },
  hbEmergencyUpdate (params) {
    return epApiFormPost('/hbEmergency/hbEmergencyUpdate', params)
  },
  hbEmergencyDelete (params) {
    return epApiFormPost('/hbEmergency/hbEmergencyDelete', params)
  },
  // 环保管家 信息披露 企业环境管理信息 生态环境违法信息
  hbIllegalInformationAdd (params) {
    return epApiFormPost('/hbIllegalInformation/hbIllegalInformationAdd', params)
  },
  hbIllegalInformationEnquiry (params) {
    return epApiGet('/hbIllegalInformation/hbIllegalInformationEnquiry', params)
  },
  hbIllegalInformationUpdate (params) {
    return epApiFormPost('/hbIllegalInformation/hbIllegalInformationUpdate', params)
  },
  hbIllegalInformationDelete (params) {
    return epApiFormPost('/hbIllegalInformation/hbIllegalInformationDelete', params)
  },
  // 环保管家 信息披露 企业环境管理信息 临时报告情况 相关投融资的生态环保信息
  hbReportingSituationAdd (params) {
    return epApiFormPost('/hbReportingSituation/hbReportingSituationAdd', params)
  },
  hbReportingSituationEnquiry (params) {
    return epApiGet('/hbReportingSituation/hbReportingSituationEnquiry', params)
  },
  hbReportingSituationUpdate (params) {
    return epApiFormPost('/hbReportingSituation/hbReportingSituationUpdate', params)
  },
  hbReportingSituationDelete (params) {
    return epApiFormPost('/hbReportingSituation/hbReportingSituationDelete', params)
  },
  // 环保管家 环保税
  hbEnvironmentalTaxAdd (params) {
    return epApiFormPost('/hbEnvironmentalTax/hbEnvironmentalTaxAdd', params)
  },
  hbEnvironmentalTaxEnquiry (params) {
    return epApiGet('/hbEnvironmentalTax/hbEnvironmentalTaxEnquiry', params)
  },
  hbEnvironmentalTaxUpdate (params) {
    return epApiFormPost('/hbEnvironmentalTax/hbEnvironmentalTaxUpdate', params)
  },
  hbEnvironmentalTaxDelete (params) {
    return epApiFormPost('/hbEnvironmentalTax/hbEnvironmentalTaxDelete', params)
  },
  // 环保管家 调查类项目
  hbSurveyAdd (params) {
    return epApiFormPost('/hbSurvey/hbSurveyAdd', params)
  },
  hbSurveyEnquiry (params) {
    return epApiGet('/hbSurvey/hbSurveyEnquiry', params)
  },
  hbSurveyUpdate (params) {
    return epApiFormPost('/hbSurvey/hbSurveyUpdate', params)
  },
  hbSurveyDelete (params) {
    return epApiFormPost('/hbSurvey/hbSurveyDelete', params)
  },
  // 环保管家 地下水
  hbSurveyDetailsAdd (params) {
    return epApiFormPost('/hbSurveyDetails/hbSurveyDetailsAdd', params)
  },
  hbSurveyDetailsEnquiry (params) {
    return epApiGet('/hbSurveyDetails/hbSurveyDetailsEnquiry', params)
  },
  hbSurveyDetailsUpdate (params) {
    return epApiFormPost('/hbSurveyDetails/hbSurveyDetailsUpdate', params)
  },
  hbSurveyDetailsDelete (params) {
    return epApiFormPost('/hbSurveyDetails/hbSurveyDetailsDelete', params)
  },
  // 环保管家 监督检查
  hbSupervisionAdd (params) {
    return epApiFormPost('/hbSupervision/hbSupervisionAdd', params)
  },
  hbSupervisionEnquiry (params) {
    return epApiGet('/hbSupervision/hbSupervisionEnquiry', params)
  },
  hbSupervisionUpdate (params) {
    return epApiFormPost('/hbSupervision/hbSupervisionUpdate', params)
  },
  hbSupervisionDelete (params) {
    return epApiFormPost('/hbSupervision/hbSupervisionDelete', params)
  },
  // 环保管家 隐患项目管理
  hbHazardsAdd (params) {
    return epApiFormPost('/hbHazards/hbHazardsAdd', params)
  },
  hbHazardsEnquiry (params) {
    return epApiGet('/hbHazards/hbHazardsEnquiry', params)
  },
  hbHazardsUpdate (params) {
    return epApiFormPost('/hbHazards/hbHazardsUpdate', params)
  },
  hbHazardsDelete (params) {
    return epApiFormPost('/hbHazards/hbHazardsDelete', params)
  },
  // 环保管家 环保交接
  hbTransitionAdd (params) {
    return epApiFormPost('/hbTransition/hbTransitionAdd', params)
  },
  hbTransitionEnquiry (params) {
    return epApiGet('/hbTransition/hbTransitionEnquiry', params)
  },
  hbTransitionUpdate (params) {
    return epApiFormPost('/hbTransition/hbTransitionUpdate', params)
  },
  hbTransitionDelete (params) {
    return epApiFormPost('/hbTransition/hbTransitionDelete', params)
  },
  // 环保管家 排放口标准化
  hbDischargeEnclosureEnquiry (params) {
    return epApiGet('/hbDischargeEnclosure/hbDischargeEnclosureEnquiry', params)
  },
  hbDischargeEnclosureDelete (params) {
    return epApiFormPost('/hbDischargeEnclosure/hbDischargeEnclosureDelete', params)
  },
  hbDischargeEnclosureUpload (params) {
    return epApiFormPost('/hbDischargeEnclosure/hbDischargeEnclosureUpload', params)
  },
  // 环保管家 废气污染源统计
  hbSourceStatisticsAdd (params) {
    return epApiFormPost('/hbSourceStatistics/hbSourceStatisticsAdd', params)
  },
  hbSourceStatisticsEnquiry (params) {
    return epApiGet('/hbSourceStatistics/hbSourceStatisticsEnquiry', params)
  },
  hbSourceStatisticsUpdate (params) {
    return epApiFormPost('/hbSourceStatistics/hbSourceStatisticsUpdate', params)
  },
  hbSourceStatisticsDelete (params) {
    return epApiFormPost('/hbSourceStatistics/hbSourceStatisticsDelete', params)
  },
  hbSourceStatisticsUpload (params) {
    return epApiFormPost('/hbSourceStatistics/hbSourceStatisticsUpload', params)
  },
  // 环保管家 安环处年度监测计划
  hbEnvironmentalMonAdd (params) {
    return epApiFormPost('/hbEnvironmentalMon/hbEnvironmentalMonAdd', params)
  },
  hbEnvironmentalMonEnquiry (params) {
    return epApiGet('/hbEnvironmentalMon/hbEnvironmentalMonEnquiry', params)
  },
  hbEnvironmentalMonUpdate (params) {
    return epApiFormPost('/hbEnvironmentalMon/hbEnvironmentalMonUpdate', params)
  },
  hbEnvironmentalMonDelete (params) {
    return epApiFormPost('/hbEnvironmentalMon/hbEnvironmentalMonDelete', params)
  },
  // 环保管家 环境质量监测结果
  hbQualityMonAdd (params) {
    return epApiFormPost('/hbQualityMon/hbQualityMonAdd', params)
  },
  hbQualityMonEnquiry (params) {
    return epApiGet('/hbQualityMon/hbQualityMonEnquiry', params)
  },
  hbQualityMonUpdate (params) {
    return epApiFormPost('/hbQualityMon/hbQualityMonUpdate', params)
  },
  hbQualityMonDelete (params) {
    return epApiFormPost('/hbQualityMon/hbQualityMonDelete', params)
  },
  // 环保管家 LDAR检测
  hbLdarDetectionAdd (params) {
    return epApiFormPost('/hbLdarDetection/hbLdarDetectionAdd', params)
  },
  hbLdarDetectionEnquiry (params) {
    return epApiGet('/hbLdarDetection/hbLdarDetectionEnquiry', params)
  },
  hbLdarDetectionUpdate (params) {
    return epApiFormPost('/hbLdarDetection/hbLdarDetectionUpdate', params)
  },
  hbLdarDetectionDelete (params) {
    return epApiFormPost('/hbLdarDetection/hbLdarDetectionDelete', params)
  },
  // 环保管家 危险废物
  hbHazardousWaltherAdd (params) {
    return epApiFormPost('/hbHazardousWalther/hbHazardousWaltherAdd', params)
  },
  hbHazardousWaltherEnquiry (params) {
    return epApiGet('/hbHazardousWalther/hbHazardousWaltherEnquiry', params)
  },
  hbHazardousWaltherUpdate (params) {
    return epApiFormPost('/hbHazardousWalther/hbHazardousWaltherUpdate', params)
  },
  hbHazardousWaltherDelete (params) {
    return epApiFormPost('/hbHazardousWalther/hbHazardousWaltherDelete', params)
  },
  hbHazardousWaltherUpload (params) {
    return epApiFormPost('/hbHazardousWalther/hbHazardousWaltherUpload', params)
  },
  // 环保管家 危险废物暂存间环保手续
  hbTemporaryStorageUpload (params) {
    return epApiFormPost('/hbTemporaryStorage/hbTemporaryStorageUpload', params)
  },
  hbTemporaryStorageEnquiry (params) {
    return epApiGet('/hbTemporaryStorage/hbTemporaryStorageEnquiry', params)
  },
  hbTemporaryStorageDelete (params) {
    return epApiFormPost('/hbTemporaryStorage/hbTemporaryStorageDelete', params)
  },
  // 环保管家 应急预案
  hbContingencyPlanAdd (params) {
    return epApiFormPost('/hbContingencyPlan/hbContingencyPlanAdd', params)
  },
  hbContingencyPlanEnquiry (params) {
    return epApiGet('/hbContingencyPlan/hbContingencyPlanEnquiry', params)
  },
  hbContingencyPlanUpdate (params) {
    return epApiFormPost('/hbContingencyPlan/hbContingencyPlanUpdate', params)
  },
  hbContingencyPlanDelete (params) {
    return epApiFormPost('/hbContingencyPlan/hbContingencyPlanDelete', params)
  },
  hbContingencyEnclosureUpload (params) {
    return epApiFormPost('/hbContingencyPlan/hbContingencyEnclosureUpload', params)
  },
  hbContingencyEnclosureEnquiry (params) {
    return epApiGet('/hbContingencyPlan/hbContingencyEnclosureEnquiry', params)
  },
  hbContingencyEnclosureDelete (params) {
    return epApiFormPost('/hbContingencyPlan/hbContingencyEnclosureDelete', params)
  },
  // 环保管家 危险废物排污许可
  hbDischargePermitAdd (params) {
    return epApiFormPost('/hbDischargePermit/hbDischargePermitAdd', params)
  },
  hbDischargePermitEnquiry (params) {
    return epApiGet('/hbDischargePermit/hbDischargePermitEnquiry', params)
  },
  hbDischargePermitUpdate (params) {
    return epApiFormPost('/hbDischargePermit/hbDischargePermitUpdate', params)
  },
  hbDischargePermitDelete (params) {
    return epApiFormPost('/hbDischargePermit/hbDischargePermitDelete', params)
  },
  hbDischargeAnnexUpload (params) {
    return epApiFormPost('/hbDischargePermit/hbDischargeAnnexUpload', params)
  },
  hbDischargeAnnexEnquiry (params) {
    return epApiGet('/hbDischargePermit/hbDischargeAnnexEnquiry', params)
  },
  hbDischargeAnnexDelete (params) {
    return epApiFormPost('/hbDischargePermit/hbDischargeAnnexDelete', params)
  },
  // 环保管家 历史遗留固废管理
  hbHistoricalSolidAdd (params) {
    return epApiFormPost('/hbHistoricalSolid/hbHistoricalSolidAdd', params)
  },
  hbHistoricalSolidEnquiry (params) {
    return epApiGet('/hbHistoricalSolid/hbHistoricalSolidEnquiry', params)
  },
  hbHistoricalSolidUpdate (params) {
    return epApiFormPost('/hbHistoricalSolid/hbHistoricalSolidUpdate', params)
  },
  hbHistoricalSolidDelete (params) {
    return epApiFormPost('/hbHistoricalSolid/hbHistoricalSolidDelete', params)
  },
  hbHistoricalEnclosureUpload (params) {
    return epApiFormPost('/hbHistoricalSolid/hbHistoricalEnclosureUpload', params)
  },
  hbHistoricalEnclosureEnquiry (params) {
    return epApiGet('/hbHistoricalSolid/hbHistoricalEnclosureEnquiry', params)
  },
  hbHistoricalEnclosureDelete (params) {
    return epApiFormPost('/hbHistoricalSolid/hbHistoricalEnclosureDelete', params)
  },
  // 环保管家 一般工业固废管理台账/填埋场信息/环保手续
  hbEnvProceduresAdd (params) {
    return epApiFormPost('/hbEnvProcedures/hbEnvProceduresAdd', params)
  },
  hbEnvProceduresEnquiry (params) {
    return epApiGet('/hbEnvProcedures/hbEnvProceduresEnquiry', params)
  },
  hbEnvProceduresUpdate (params) {
    return epApiFormPost('/hbEnvProcedures/hbEnvProceduresUpdate', params)
  },
  hbEnvProceduresDelete (params) {
    return epApiFormPost('/hbEnvProcedures/hbEnvProceduresDelete', params)
  },
  // 环保管家 公告管理
  hbAnnouncementAdd (params) {
    return epApiFormPost('/hbAnnouncement/hbAnnouncementAdd', params)
  },
  hbAnnouncementEnquiry (params) {
    return epApiGet('/hbAnnouncement/hbAnnouncementEnquiry', params)
  },
  hbAnnouncementUpdate (params) {
    return epApiFormPost('/hbAnnouncement/hbAnnouncementUpdate', params)
  },
  hbAnnouncementDelete (params) {
    return epApiFormPost('/hbAnnouncement/hbAnnouncementDelete', params)
  },
  // 环保管家 公告管理 附件
  hbAnnouncementAnnexUpload (params) {
    return epApiFormPost('/hbAnnouncementAnnex/hbAnnouncementAnnexUpload', params)
  },
  hbAnnouncementAnnexEnquiry (params) {
    return epApiGet('/hbAnnouncementAnnex/hbAnnouncementAnnexEnquiry', params)
  },
  hbAnnouncementAnnexDelete (params) {
    return epApiFormPost('/hbAnnouncementAnnex/hbAnnouncementAnnexDelete', params)
  },
  // 环保管家 部门管理
  hbDepartmentAdd (params) {
    return epApiFormPost('/hbDepartment/hbDepartmentAdd', params)
  },
  hbDepartmentList (params) {
    return epApiGet('/hbDepartment/hbDepartmentList', params)
  },
  hbDepartmentUpdate (params) {
    return epApiFormPost('/hbDepartment/hbDepartmentUpdate', params)
  },
  hbDepartmentDelete (params) {
    return epApiFormPost('/hbDepartment/hbDepartmentDelete', params)
  },
  // 环保管家 人事中心
  hbJurisdictionAdd (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionAdd', params)
  },
  hbJurisdictionEnquiry (params) {
    return epApiGet('/hbJurisdiction/hbJurisdictionEnquiry', params)
  },
  hbJurisdictionUpdate (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionUpdate', params)
  },
  hbJurisdictionDelete (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionDelete', params)
  },
  hbJurisdictionSearch (params) {
    return epApiFormPost('/hbJurisdiction/hbJurisdictionSearch', params)
  },
  appUserHighestPosition (params) {
    return epApiGet('/appUser/appUserHighestPosition', params)
  },
  appUserPhone (params) {
    return epApiFormPost('/appUser/appUserPhone', params)
  },
  appUserSaveCptCode (params) {
    return epApiFormPost('/appUser/text', params)
  },
  // 环保管家 危废管理计划
  hbManagementScheduleAdd (params) {
    return epApiFormPost('/hbManagementSchedule/hbManagementScheduleAdd', params)
  },
  hbManagementScheduleEnquiry (params) {
    return epApiGet('/hbManagementSchedule/hbManagementScheduleEnquiry', params)
  },
  hbManagementScheduleUpdate (params) {
    return epApiFormPost('/hbManagementSchedule/hbManagementScheduleUpdate', params)
  },
  hbManagementScheduleDelete (params) {
    return epApiFormPost('/hbManagementSchedule/hbManagementScheduleDelete', params)
  },
  hbHazardousWaste (params) {
    return epApiFormPost('/hbApprovalMaterials/hbHazardousWaste', params)
  },
  // 环保管家 危废管理计划 管理部门
  hbAdministerDepartmentAdd (params) {
    return epApiFormPost('/hbAdministerDepartment/hbAdministerDepartmentAdd', params)
  },
  hbAdministerDepartmentEnquiry (params) {
    return epApiGet('/hbAdministerDepartment/hbAdministerDepartmentEnquiry', params)
  },
  hbAdministerDepartmentUpload (params) {
    return epApiFormPost('/hbAdministerDepartment/hbAdministerDepartmentUpload', params)
  },
  // 环保管家 危废管理计划 危险废物产生概况
  hbGenerationOverviewAdd (params) {
    return epApiFormPost('/hbGenerationOverview/hbGenerationOverviewAdd', params)
  },
  hbGenerationOverviewEnquiry (params) {
    return epApiGet('/hbGenerationOverview/hbGenerationOverviewEnquiry', params)
  },
  hbGenerationOverviewUpdate (params) {
    return epApiFormPost('/hbGenerationOverview/hbGenerationOverviewUpdate', params)
  },
  hbGenerationOverviewDelete (params) {
    return epApiFormPost('/hbGenerationOverview/hbGenerationOverviewDelete', params)
  },
  // 环保管家 危废管理计划 危险废物转移情况
  hbHazardousWasteAdd (params) {
    return epApiFormPost('/hbHazardousWaste/hbHazardousWasteAdd', params)
  },
  hbHazardousWasteEnquiry (params) {
    return epApiGet('/hbHazardousWaste/hbHazardousWasteEnquiry', params)
  },
  hbHazardousWasteUpdate (params) {
    return epApiFormPost('/hbHazardousWaste/hbHazardousWasteUpdate', params)
  },
  hbHazardousWasteDelete (params) {
    return epApiFormPost('/hbHazardousWaste/hbHazardousWasteDelete', params)
  },
  // 环保管家 危废管理计划 危险废物委托利用/处置措施 基本信息
  hbSelfUtilizationAdd (params) {
    return epApiFormPost('/hbSelfUtilization/hbSelfUtilizationAdd', params)
  },
  hbSelfUtilizationEnquiry (params) {
    return epApiGet('/hbSelfUtilization/hbSelfUtilizationEnquiry', params)
  },
  hbSelfUtilizationUpdate (params) {
    return epApiFormPost('/hbSelfUtilization/hbSelfUtilizationUpdate', params)
  },
  hbSelfUtilizationDelete (params) {
    return epApiFormPost('/hbSelfUtilization/hbSelfUtilizationDelete', params)
  },
  // 环保管家 危废管理计划 危险废物委托利用/处置措施 危险废物自行利用处置情况
  hbDisposalAdd (params) {
    return epApiFormPost('/hbDisposal/hbDisposalAdd', params)
  },
  hbDisposalEnquiry (params) {
    return epApiGet('/hbDisposal/hbDisposalEnquiry', params)
  },
  hbDisposalUpdate (params) {
    return epApiFormPost('/hbDisposal/hbDisposalUpdate', params)
  },
  hbDisposalDelete (params) {
    return epApiFormPost('/hbDisposal/hbDisposalDelete', params)
  },
  // 环保管家 危废管理计划 危险废物委托利用/处置措施
  hbEntrustedUtilizationAdd (params) {
    return epApiFormPost('/hbEntrustedUtilization/hbEntrustedUtilizationAdd', params)
  },
  hbEntrustedUtilizationEnquiry (params) {
    return epApiGet('/hbEntrustedUtilization/hbEntrustedUtilizationEnquiry', params)
  },
  hbEntrustedUtilizationUpdate (params) {
    return epApiFormPost('/hbEntrustedUtilization/hbEntrustedUtilizationUpdate', params)
  },
  hbEntrustedUtilizationDelete (params) {
    return epApiFormPost('/hbEntrustedUtilization/hbEntrustedUtilizationDelete', params)
  },
  // 环保管家 危废管理计划 上传图片
  hbWasteEnclosureUpload (params) {
    return epApiFormPost('/hbWasteEnclosure/hbWasteEnclosureUpload', params)
  },
  hbWasteEnclosureEnquiry (params) {
    return epApiGet('/hbWasteEnclosure/hbWasteEnclosureEnquiry', params)
  },
  hbWasteEnclosureDelete (params) {
    return epApiFormPost('/hbWasteEnclosure/hbWasteEnclosureDelete', params)
  },
  // 环保管家 危废管理计划 总表
  hbPlanDetailsAdd (params) {
    return epApiFormPost('/hbPlanDetails/hbPlanDetailsAdd', params)
  },
  hbPlanDetailsEnquiry (params) {
    return epApiGet('/hbPlanDetails/hbPlanDetailsEnquiry', params)
  },
  hbPlanDetailsUpdate (params) {
    return epApiFormPost('/hbPlanDetails/hbPlanDetailsUpdate', params)
  },
  hbPlanDetailsDelete (params) {
    return epApiFormPost('/hbPlanDetails/hbPlanDetailsDelete', params)
  },
  // 排污许可 废气排放口
  hbWasteGasAdd (params) {
    return epApiFormPost('/hbWasteGas/hbWasteGasAdd', params)
  },
  hbWasteGasEnquiry (params) {
    return epApiGet('/hbWasteGas/hbWasteGasEnquiry', params)
  },
  hbWasteGasUpdate (params) {
    return epApiFormPost('/hbWasteGas/hbWasteGasUpdate', params)
  },
  hbWasteGasDelete (params) {
    return epApiFormPost('/hbWasteGas/hbWasteGasDelete', params)
  },
  // 排污许可 废水排放口
  hbWasteWaterAdd (params) {
    return epApiFormPost('/hbWasteWater/hbWasteWaterAdd', params)
  },
  hbWasteWaterEnquiry (params) {
    return epApiGet('/hbWasteWater/hbWasteWaterEnquiry', params)
  },
  hbWasteWaterUpdate (params) {
    return epApiFormPost('/hbWasteWater/hbWasteWaterUpdate', params)
  },
  hbWasteWaterDelete (params) {
    return epApiFormPost('/hbWasteWater/hbWasteWaterDelete', params)
  },
  // 排污许可 执行报告 年报 智能填报总表
  hbImplementReportAllAdd (params) {
    return epApiFormPost('/hbImplementReport/hbImplementReportAllAdd', params)
  },
  hbImplementReportAllEnquiry (params) {
    return epApiGet('/hbImplementReport/hbImplementReportAllEnquiry', params)
  },
  // 排污许可 燃料煤详情
  hbFuelCoalAdd (params) {
    return epApiFormPost('/hbFuelCoal/hbFuelCoalAdd', params)
  },
  hbFuelCoalEnquiry (params) {
    return epApiGet('/hbFuelCoal/hbFuelCoalEnquiry', params)
  },
  hbFuelCoalUpdate (params) {
    return epApiFormPost('/hbFuelCoal/hbFuelCoalUpdate', params)
  },
  // 排污许可 执行报告 附件
  hbAnnexUpload (params) {
    return epApiFormPost('/hbAnnex/hbAnnexUpload', params)
  },
  hbAnnexEnquiry (params) {
    return epApiGet('/hbAnnex/hbAnnexEnquiry', params)
  },
  hbAnnexDelete (params) {
    return epApiFormPost('/hbAnnex/hbAnnexDelete', params)
  },
  hbAnnexUpdate (params) {
    return epApiFormPost('/hbAnnex/hbAnnexUpdate', params)
  },
  // 排污许可 执行报告 企业基本信息
  HbEnterpriseSituationAdd (params) {
    return epApiFormPost('/hbEnterpriseSituation/HbEnterpriseSituationAdd', params)
  },
  HbEnterpriseSituationEnquiry (params) {
    return epApiGet('/hbEnterpriseSituation/HbEnterpriseSituationEnquiry', params)
  },
  HbEnterpriseSituationDelete (params) {
    return epApiFormPost('/hbEnterpriseSituation/HbEnterpriseSituationDelete', params)
  },
  // 排污许可 信息公开表公示信息
  hbCompanyDisclosureAdd (params) {
    return epApiFormPost('/hbCompanyDisclosure/hbCompanyDisclosureAdd', params)
  },
  // hbCompanyDisclosureEnquiry (params) {
  //   return epApiGet('/hbCompanyDisclosure/hbCompanyDisclosureEnquiry', params)
  // },
  hbCompanyEnclosureUpload (params) {
    return epApiFormPost('/hbCompanyDisclosure/hbCompanyEnclosureUpload', params)
  },
  // hbCompanyEnclosureEnquiry (params) {
  //   return epApiGet('/hbCompanyDisclosure/hbCompanyEnclosureEnquiry', params)
  // },
  deleteHbEnclosure (params) {
    return epApiFormPost('/hbCompanyDisclosure/hbEnclosureDelete', params)
  },
  hbAnnouncementAddOne (params) {
    return epApiFormPost('/hbAnnouncement/hbAnnouncementAddOne', params)
  },
  // 排污许可 信息公开表公示信息新1
  hbDisclosureOneAdd (params) {
    return epApiFormPost('/hbDisclosureOne/hbDisclosureOneAdd', params)
  },
  hbDisclosureOneUpdate (params) {
    return epApiFormPost('/hbDisclosureOne/hbDisclosureOneUpdate', params)
  },
  hbDisclosureOneDelete (params) {
    return epApiFormPost('/hbDisclosureOne/hbDisclosureOneDelete', params)
  },
  // 排污许可 信息公开表公示信息新2
  hbDisclosureTwoAdd (params) {
    return epApiFormPost('/hbDisclosureTwo/hbDisclosureTwoAdd', params)
  },
  hbDisclosureTwoUpdate (params) {
    return epApiFormPost('/hbDisclosureTwo/hbDisclosureTwoUpdate', params)
  },
  hbDisclosureTwoDelete (params) {
    return epApiFormPost('/hbDisclosureTwo/hbDisclosureTwoDelete', params)
  },
  // 排污许可 信息公开表公示信息新3
  hbDisclosureThreeAdd (params) {
    return epApiFormPost('/hbDisclosureThree/hbDisclosureThreeAdd', params)
  },
  hbDisclosureThreeUpdate (params) {
    return epApiFormPost('/hbDisclosureThree/hbDisclosureThreeUpdate', params)
  },
  hbDisclosureThreeDelete (params) {
    return epApiFormPost('/hbDisclosureThree/hbDisclosureThreeDelete', params)
  },
  // 环保管家 自行监测 监测方案信息
  hbMonitoringSchemeAdd (params) {
    return epApiFormPost('/hbMonitoringScheme/hbMonitoringSchemeAdd', params)
  },
  hbMonitoringSchemeEnquiry (params) {
    return epApiGet('/hbMonitoringScheme/hbMonitoringSchemeEnquiry', params)
  },
  hbMonitoringSchemeUpdate (params) {
    return epApiFormPost('/hbMonitoringScheme/hbMonitoringSchemeUpdate', params)
  },
  hbMonitoringSchemeDelete (params) {
    return epApiFormPost('/hbMonitoringScheme/hbMonitoringSchemeDelete', params)
  },
  // 环保管家 自行监测 不监测原因管理
  hbNonMonitoringAdd (params) {
    return epApiFormPost('/hbNonMonitoring/hbNonMonitoringAdd', params)
  },
  hbNonMonitoringEnquiry (params) {
    return epApiGet('/hbNonMonitoring/hbNonMonitoringEnquiry', params)
  },
  hbNonMonitoringUpdate (params) {
    return epApiFormPost('/hbNonMonitoring/hbNonMonitoringUpdate', params)
  },
  hbNonMonitoringDelete (params) {
    return epApiFormPost('/hbNonMonitoring/hbNonMonitoringDelete', params)
  },
  // 环保管家 自行监测 用户信息管理
  hbMonitoringProgrammeAdd (params) {
    return epApiFormPost('/hbMonitoringProgramme/hbMonitoringProgrammeAdd', params)
  },
  hbMonitoringProgrammeEnquiry (params) {
    return epApiGet('/hbMonitoringProgramme/hbMonitoringProgrammeEnquiry', params)
  },
  hbMonitoringProgrammeUpdate (params) {
    return epApiFormPost('/hbMonitoringProgramme/hbMonitoringProgrammeUpdate', params)
  },
  hbMonitoringProgrammeDelete (params) {
    return epApiFormPost('/hbMonitoringProgramme/hbMonitoringProgrammeDelete', params)
  },
  // 环保管家 自行监测 企业改正情况
  hbEnterpriseCorrectionAdd (params) {
    return epApiFormPost('/hbEnterpriseCorrection/hbEnterpriseCorrectionAdd', params)
  },
  hbEnterpriseCorrectionEnquiry (params) {
    return epApiGet('/hbEnterpriseCorrection/hbEnterpriseCorrectionEnquiry', params)
  },
  hbEnterpriseCorrectionUpdate (params) {
    return epApiFormPost('/hbEnterpriseCorrection/hbEnterpriseCorrectionUpdate', params)
  },
  hbEnterpriseCorrectionDelete (params) {
    return epApiFormPost('/hbEnterpriseCorrection/hbEnterpriseCorrectionDelete', params)
  },
  // 环保管家 台账
  hbStandingBookAdd (params) {
    return epApiFormPost('/hbStandingBook/hbStandingBookAdd', params)
  },
  hbStandingBookEnquiry (params) {
    return epApiGet('/hbStandingBook/hbStandingBookEnquiry', params)
  },
  hbStandingBookUpdate (params) {
    return epApiFormPost('/hbStandingBook/hbStandingBookUpdate', params)
  },
  hbStandingBookDelete (params) {
    return epApiFormPost('/hbStandingBook/hbStandingBookDelete', params)
  },
  hbStandingBookUpload (params) {
    return epApiFormPost('/hbStandingBook/hbStandingBookUpload', params)
  },
  // 环保管家 环保通讯
  hbCommunicationAdd (params) {
    return epApiFormPost('/hbCommunication/hbCommunicationAdd', params)
  },
  hbCommunicationEnquiry (params) {
    return epApiGet('/hbCommunication/hbCommunicationEnquiry', params)
  },
  hbCommunicationUpdate (params) {
    return epApiFormPost('/hbCommunication/hbCommunicationUpdate', params)
  },
  hbCommunicationDelete (params) {
    return epApiFormPost('/hbCommunication/hbCommunicationDelete', params)
  },
  // 环保管家 危险废物标签
  hbHazardousLabelAdd (params) {
    return epApiFormPost('/hbHazardousLabel/hbHazardousLabelAdd', params)
  },
  hbHazardousLabelEnquiry (params) {
    return epApiGet('/hbHazardousLabel/hbHazardousLabelEnquiry', params)
  },
  hbHazardousLabelUpdate (params) {
    return epApiFormPost('/hbHazardousLabel/hbHazardousLabelUpdate', params)
  },
  hbHazardousLabelDelete (params) {
    return epApiFormPost('/hbHazardousLabel/hbHazardousLabelDelete', params)
  },
  hbHazardousLabelDerive (params) {
    return epApiFormPost('/hbHazardousLabel/hbHazardousLabelDerive', params)
  },
  hbHazardousLabelCode (params) {
    return epApiFormPost('/hbHazardousLabel/hbHazardousLabelCode', params)
  },
  hbHazardousLabelInformation (params) {
    return epApiFormPost('/hbHazardousLabel/hbHazardousLabelInformation', params)
  },
  hbHazardousLabelDeriveOne (params) {
    return epApiFormPost('/hbHazardousLabel/hbHazardousLabelDeriveOne', params)
  },
  /* 获取移动版下载地址 */
  checkUpdate (params) {
    return epApiGet('/personal/detectionUpdate', params)
  },
  // label
  cipherList (params) {
    return epApiGet('/hbHazardousLabel/cipherList', params)
  },
  // 采样原始距离二维码内容
  jcOriginalLogCipherList (params) {
    return epApiGet('/originalRecord/jcOriginalLogCipherList', params)
  },
  // eng
  hbInformationSignsCipher (params) {
    return epApiGet('/hbInformationSigns/hbInformationSignsCipher', params)
  },
  // 常见问题说明
  cdIntelligentSearch (params) {
    return epApiPost('/cdIntelligent/cdIntelligentSearch', params)
  },
  // 订阅文件
  ssOne2 (params) {
    return epApiGet('/catalogs/ssOne2', params)
  },
  ssOne2Search (params) {
    return epApiGet('/catalogs/ssOne2Search', params)
  },
  // 环境咨询 内审复核 环评内审
  cdSummaryTableImport (params) {
    return epApiFormPost('/cdSummaryTable/cdSummaryTableImport', params)
  },
  cdSummaryTableEnquiry (params) {
    return epApiGet('/cdSummaryTable/cdSummaryTableEnquiry', params)
  },
  cdSummaryTableDownload (params) {
    return epApiFormPost('/cdSummaryTable/cdSummaryTableDownload', params)
  },
  cdSummaryTableAdd (params) {
    return epApiFormPost('/cdSummaryTable/cdSummaryTableAdd', params)
  },
  cdSummaryTableDelete (params) {
    return epApiFormPost('/cdSummaryTable/cdSummaryTableDelete', params)
  },
  cdSummaryTableUpload (params) {
    return epApiFormPost('/cdSummaryTable/cdSummaryTableUpload', params)
  },
  // 在线评估
  /* 权限管理接口 */
  // jcJurisdictionAdd (params) {
  //   return epApiFormPost('/jcJurisdiction/jcJurisdictionAdd', params)
  // },
  jcJurisdictionAdd (params) {
    return epApiFormPost('/cdAppPersonnel/jcJurisdictionAdd', params)
  },
  jcJurisdictionDelete (params) {
    return epApiFormPost('/jcJurisdiction/jcJurisdictionDelete', params)
  },
  jcJurisdictionUpdate (params) {
    return epApiFormPost('/jcJurisdiction/jcJurisdictionUpdate', params)
  },
  jcJurisdictionEnquiry (params) {
    return epApiFormPost('/jcJurisdiction/jcJurisdictionEnquiry', params)
  },
  // jcJurisdictionSearch (params) {
  //   return epApiFormPost('/jcJurisdiction/jcJurisdictionSearch', params)
  // },
  jcJurisdictionSearch (params) {
    return epApiFormPost('/cdAppPersonnel/jcJurisdictionSearch', params)
  },
  // 在线评估表格
  cdEiaStatusStatistics (params) {
    return epApiGet('/cdEiaStatus/cdEiaStatusStatistics', params)
  },
  cdEiaStatusEnquiry (params) {
    return epApiGet('/cdEiaStatus/cdEiaStatusEnquiry', params)
  },
  cdEiaStatusAdd (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusAdd', params)
  },
  cdEiaStatusDelete (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusDelete', params)
  },
  cdEiaStatusUpdate (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusUpdate', params)
  },
  cdEiaStatusAllUsers (params) {
    return epApiGet('/cdEiaStatus/cdEiaStatusAllUsers', params)
  },
  cdEiaStatusUpload (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusUpload', params)
  },
  cdEiaStatusResolution (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusResolution', params)
  },
  cdEiaStatusDownload (params) {
    return epApiFormPost('/cdEiaStatus/cdEiaStatusDownload', params)
  },
  cdEiaEnclosureAllEnquiry (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureAllEnquiry', params)
  },
  cdEiaEnclosureUpload (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureUpload', params)
  },
  cdEiaEnclosureDelete (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureDelete', params)
  },
  cdEiaEnclosureEnquiry (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaEnclosureEnquiry', params)
  },
  // companyNameByEnquiry (params) {
  //   return epApiFormPost('/companyName/companyNameByEnquiry', params)
  // },
  cdEiaJournalAdd (params) {
    return epApiFormPost('/cdEiaEnclosure/cdEiaJournalAdd', params)
  },
  cdEiaJournalEnquiry (params) {
    return epApiGet('/cdEiaEnclosure/cdEiaJournalEnquiry', params)
  },
  /* 公司名字接口 */
  companyNameEnquiry (params) {
    return epApiGet('/companyName/companyNameEnquiry', params)
  },
  companyNameAdd (params) {
    return epApiFormPost('/companyName/companyNameAdd', params)
  },
  companyNameDelete (params) {
    return epApiGet('/companyName/companyNameDelete', params)
  },
  companyNameUpdate (params) {
    return epApiFormPost('/companyName/companyNameUpdate', params)
  },
  companyNameByEnquiry (params) {
    return epApiFormPost('/companyName/companyNameByEnquiry', params)
  },
  // 首页左右两侧广告
  noticeAdvertising (params) {
    return epApiGet('/notice/noticeAdvertising', params)
  },
  publicityTwo (params) {
    return epApiGet('/publicity/publicityTwo', params)
  },
  // 登录验证码
  publicityCode (params) {
    return epApiGet('/publicity/publicityCode', params)
  },
  // 会员说明接口
  publicityDescription (params) {
    return epApiGet('/publicity/publicityDescription', params)
  },
  // 会员扣豆接口
  publicityMembers (params) {
    return epApiGet('/publicity/publicityMembers', params)
  },
  // 分享 单位排行详情
  // 会员扣豆接口
  cdCreditScoreId (params) {
    return epApiGet('/creditPlatform/cdCreditScoreId', params)
  },
  // 小智问答 智能问答 分享页
  cdAshKetchupAnswerId (params) {
    return epApiGet('/cdAshKetchup/cdAshKetchupAnswerId', params)
  },
  // 小智问答
  cdAshKetchupEnquiry (params) {
    return epApiGet('/cdAshKetchup/cdAshKetchupEnquiry', params)
  },
  cdAshKetchupEnquiryOne (params) {
    return epApiGet('/cdAshKetchup/cdAshKetchupEnquiryOne', params)
  },
  cdAshFileAdd (params) {
    return epApiGet('/cdAshKetchup/cdAshFileAdd', params)
  },
  // 新版小智问答
  cdAshKetchupDialogue (params) {
    return epApiPost('/cdAshKetchup/cdAshKetchupDialogue', params)
  },
  cdAshKetchupDialogueTwo (params) {
    return epApiPost('/cdAshKetchup/cdAshKetchupDialogueTwo', params)
  },
  cdAshKetchupDialogueThree (params) {
    return epApiPost('/cdAshKetchupDialogue/cdAshKetchupDialogueThree', params)
  },
  cdAshKetchupDialogueFour (params) {
    return epApiPost('/cdAshKetchup/cdAshKetchupDialogueFour', params)
  },
  cdAshKetchupModelList (params) {
    return epApiGet('/cdAshKetchup/cdAshKetchupModelList', params)
  },
  cdAshKetchupZskwjEnquiry (params) {
    return epApiGet('/cdAshKetchup/cdAshKetchupZskwjEnquiry', params)
  },
  cdAshKetchupZskwjDelete (params) {
    return epApiGet('/cdAshKetchup/cdAshKetchupZskwjDelete', params)
  },
  cdAshKetchupOneUpload (params) {
    return epApiFormPost('/cdAshKetchup/cdAshKetchupOneUpload', params)
  },
  // 鸿蒙5.0以上版本网页查看文件
  fileUploadEnquiry (params) {
    return epApiGet('/fileUpload/fileUploadEnquiry', params)
  }
}
